import React, { useEffect, useState } from 'react';

interface IProps {
  percent: number;
}

const BatteryItem = (props: IProps) => {
  const [barCnt, setBarCnt] = useState<number>(0);
  const [barColor, setBarColor] = useState<string>('#000000');

  useEffect(() => {
    if (props.percent != null) {
      setBarCnt(getBatteryCnt(props.percent));
      setBarColor(getBatteryColor(props.percent));
    }
  }, [props.percent]);

  const getBatteryCnt = (percent: number): number => {
    if (percent >= 100) return 5;
    if (percent >= 80) return 4;
    if (percent >= 60) return 3;
    if (percent >= 40) return 2;
    if (percent >= 20) return 1;
    return 0;
  };

  const getBatteryColor = (percent: number): string => {
    if (percent >= 100) return '#2AC29C';
    if (percent >= 80) return '#FEDD20';
    if (percent >= 60) return '#F46427';
    return '#F46427';
  };

  return (
    <div className={'battery-item'}>
      <div className={'battery-body1'}>
        {Array.from({ length: barCnt }).map((_, index) => (
          <div
            key={index}
            className={'barrery-bar'}
            style={{ backgroundColor: barColor, border: '1px solid ' + barColor }}
          ></div>
        ))}
      </div>
      <div className={'battery-body2'}></div>
    </div>
  );
};

export default BatteryItem;
